import EventEmitter from 'events';

class LizzyApi extends EventEmitter {
  constructor() {
    super();
    
    this.lizzy = null;
    this.updateCurrentLine = this.updateCurrentLine.bind(this);
    this.callbacks = {};
    this.lastAction = {
      id: '',
      args: [],
    };
    this.isStop = false;
  }

  mount(lizzy) {
    if (!this.lizzy) {
      this.lizzy = lizzy;

      this.lizzy.registerCallbacks({
        onConncted: () => this.emit('connected'),
        onDisconncted: () => this.emit('disconncted'),
        onUpdateAutoCompleteData: (posid, result) => 
          this.emit('updateAutoCompleteData', { posid, result }),
        onClearAutoCompleteData: (posid) =>
          this.emit('clearAutoCompleteData', { posid }),

        onGetCurrentClause: () => {
          return this.callbacks.onGetCurrentClause();
        },
        onGetSentences: (lines) => {
          return this.callbacks.onGetSentences(lines);
        },
        onGetDocument: (currenthash) => {
          return this.callbacks.onGetDocument(currenthash);
        },
        openLizzyPopup(options) {
          return this.callbacks.openLizzyPopup(options);
        },
        onCloseLizzyPopup() {
          return this.callbacks.onCloseLizzyPopup();
        }
      });

      this.on('updateCurrentLine', this.updateCurrentLine);
      lizzy.authenticate();
    }
  }

  unmount() {
    
  }

  run(actionId) {
    if (!(actionId in this)) {
      throw new Error(`No such method '${actionId} in the lizzy api adapter'`);
    }

    return (...args) => {
      this.lastAction.id = actionId;
      this.lastAction.args = args;
      return this[actionId].call(this, ...args);
    };
  }

  updateCurrentLine({ toCaret, fromCaret }) {
    console.log();
    this.lizzy.updateCurrentLine({
      toCaret,
      fromCaret
    });
  }

  completeSentence(callback) {
    this.lizzy.generateText('complete_sentence', callback);
  }

  completeClause(callback) {
    this.lizzy.generateText('complete_clause', callback);
  }

  generateTextWithParams(actionId, params, callback) {
    this.isStop = false;
    this.lizzy.generateTextWithParams(actionId, params, (result) => {
      callback(result);

      if (this.isStop) {
        return { stop: true };
      };
    });
  }

  generateTextResponse({ prompt, selectedText }, callback) {
    this.generateTextWithParams('prompt_output', { prompt, selectedText }, (result) => {
      callback(result);
      this.emit('generateTextResponse', result)
    });
  }

  generateSummaries({ selectedText }, callback) {
    this.generateTextWithParams('selection_summaries', { selectedText }, (result) => {
      callback(result);
      this.emit('generateSummariesResponse', result)
    });
  }

  continueWriting({ selectedText }, callback) {
    this.generateTextWithParams('selection_continue_writing', { selectedText }, (result) => {
      callback(result);
      this.emit('continueWritingResponse', result);
    });
  }

  makeShorter({ selectedText }, callback) {
    this.generateTextWithParams('selection_make_shorter', { selectedText }, (result) => {
      callback(result);
      this.emit('makeShorterResponse', result);
    });
  }

  makeLonger({ selectedText }, callback) {
    this.generateTextWithParams('selection_make_longer', { selectedText }, (result) => {
      callback(result);
      this.emit('makeLongerResponse', result);
    });
  }

  rephrase({ selectedText }, callback) {
    this.generateTextWithParams('selection_rephrase', { selectedText }, (result) => {
      callback(result);
      this.emit('rephraseResponse', result);
    });
  }

  stopGenerate() {
    this.isStop = true;
  }

  restartLastAction() {
    if (!this.lastAction.id) {
      throw new Error('No last action');
    }

    this.stopGenerate();
    this.run(this.lastAction.id)(...this.lastAction.args)
  }

  assignCallbacks({
    onGetCurrentClause,
    onGetSentences,
    onGetDocument,
    openLizzyPopup,
    onCloseLizzyPopup,
  } = {}) {
    this.callbacks.onGetCurrentClause = onGetCurrentClause || (() => {});
    this.callbacks.onGetSentences = onGetSentences || (() => {});
    this.callbacks.onGetDocument = onGetDocument || (() => {});
    this.callbacks.openLizzyPopup = openLizzyPopup || (() => {});
    this.callbacks.onCloseLizzyPopup = onCloseLizzyPopup || (() => {});
  }
}

const lizzyApi = new LizzyApi(window.lizzy);

export default lizzyApi;